import * as types from './types'
import storage from '@/plugins/storage'

export default {
  [types.SET_CRITERIA_CHANGED](state, value) {
    state.criteriaChanged = value
  },
  [types.SET_STEP](state, data) {
    state.step = data
  },
  [types.SET_VISITED_STEP](state, currentStep) {
    state.visitedStep = currentStep > state.visitedStep ? currentStep : state.visitedStep
  },
  [types.RESET_VISITED_STEP](state, data) {
    state.visitedStep = data
  },
  [types.PREP_RECOMMENDATION](state, firm) {
    state.recommendation.firm = firm
    state.recommendation.testDriveRecommendation = null
  },
  [types.SET_RECOMMENDATIONS](state, data) {
    state.recommendations = data
  },
  [types.SET_RECOMMENDATION](state, data) {
    state.recommendation = data
  },
  [types.RESET_TRANSLATIONS](state, data) {
    state.translations = []
  },
  [types.SET_TRANSLATIONS](state, data) {
    state.translations = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.translations = data
      }
    }
  },
  [types.RESET_RESULTTYPE](state) {
    state.testdriveResultType = JSON.parse(JSON.stringify(state.newResultType))
  },
  [types.SET_RESULTTYPES](state, data) {
    state.testdriveResultTypes = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.testdriveResultTypes = data
      }
    }
  },
  [types.SET_RESULTTYPE](state, data) {
    state.testdriveResultType = JSON.parse(JSON.stringify(state.newResultType))
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.testdriveResultType = data[0]
      }
    }
  },
  [types.UPDATE_RESULTTYPE](state, data) {
    if (state.testdriveResultType !== null && data !== null) {
      switch (data.name) {
        case 'firm':
          state.testdriveResultType.firm = parseInt(data.value)
          break
        case 'year':
          if (data.value === null || data.value === '') {
            state.testdriveResultType.year = null
          } else {
            state.testdriveResultType.year = parseInt(data.value)
          }
          break
        case 'vehicleMake':
          if (data.value === null || data.value === '') {
            state.testdriveResultType.vehicleMake = null
          } else {
            state.testdriveResultType.vehicleMake = parseInt(data.value)
          }
          break
        case 'driveType':
          if (data.value === null || data.value === '') {
            state.testdriveResultType.driveType = null
          } else {
            state.testdriveResultType.driveType = parseInt(data.value)
          }
          break
        case 'testdriveResultTypeName':
          state.testdriveResultType.testdriveResultTypeName = data.value
          break
        case 'testdriveResultCode':
          state.testdriveResultType.testdriveResultCode = data.value
          break
      }
    }
  },
  [types.INIT_ADAS_MATRIX](state) {
    state.adasmatrix = JSON.parse(JSON.stringify(state.newadasmatrix))
  },
  [types.UPDATE_ADAS_MATRIX](state, data) {
    // console.log('Update ADAS Matrix', {
    //   matrix: state.adasmatrix,
    //   data: data
    // })
    if (state.adasmatrix !== null && data !== null) {
      switch (data.name) {
        case 'matrixItem':
          state.adasmatrix.matrixItem = data.value
          break
        case 'sort':
          state.adasmatrix.sort = parseInt(data.value)
          break
        case 'isInactive':
          state.adasmatrix.isInactive = data.value
          break
        case 'isHighlight':
          state.adasmatrix.isHighlight = data.value
          break
        case 'notice':
          state.adasmatrix.notice = data.value
          break
        case 'hints':
          state.adasmatrix.hints = data.value
          break
        case 'keywords':
          state.adasmatrix.keywords = data.value
          break
      }
    }
  },
  [types.SET_ADAS_MATRIX](state, id) {
    let cnt = 0
    state.adasmatrix = JSON.parse(JSON.stringify(state.newadasmatrix))
    let found = state.adasmatrices.find((x) => parseInt(x.adasChecklistMatrix) === parseInt(id))
    if (found !== undefined && found !== null) {
      state.adasmatrix = JSON.parse(JSON.stringify(found))
      if (state.adasmatrix.items !== null) {
        state.adasmatrix.items.forEach((element) => {
          element.id = cnt
          element.isRemove = false
          cnt++
        })
      } else {
        state.adasmatrix.items = []
      }
    }
  },
  [types.UPDATE_ADAS_MATRIXITEM](state, data) {
    if (state.adasmatrix !== null && data !== null) {
      let lastId = 0
      let found = null
      if (state.adasmatrix.items.length > 0) {
        lastId = state.adasmatrix.items[state.adasmatrix.items.length - 1].id + 1
      }
      switch (data.action) {
        case 'add':
          state.adasmatrix.items.push({
            id: lastId,
            adasChecklistMatrixItem: null,
            adasChecklistMatrix: state.adasmatrix.adasChecklistMatrix,
            isRemove: false,
            item: data.value
          })
          break
        case 'save':
          found = state.adasmatrix.items.find((x) => parseInt(x.id) === parseInt(data.id))
          if (found !== undefined && found !== null) {
            found.item = data.value
          }
          break
        case 'remove':
          found = state.adasmatrix.items.find((x) => parseInt(x.id) === parseInt(data.id))
          if (found !== undefined && found !== null) {
            found.isRemove = true
          }
          break
      }
    }
  },
  [types.SET_ADAS_EXCLUSIONS](state, data) {
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.exclusions = data
      }
    }
  },
  [types.SET_ADAS_MATRICES](state, data) {
    state.adasmatrices = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.adasmatrices = data
        console.log('Storing to Session', state.adasmatrices)
        storage.session.setItem(types.SESSION_ADAS_MATRIX, JSON.stringify(state.adasmatrices))
      }
    }
  },
  [types.SET_DECODED_VIN](state, data) {
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.decodedVin = data
      }
    }
  },
  [types.SET_DECODED_ALT_VIN](state, data) {
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.decodedAltVin = data
      }
    }
  },
  [types.INIT_ADAS_MAKE_MATRIX](state) {
    state.adasmakematrix = JSON.parse(JSON.stringify(state.newadasmakematrix))
    console.log('A new ADAS Make Matrix', state.adasmakematrix)
  },
  [types.UPDATE_ADAS_MAKE_MATRIX](state, data) {
    if (state.adasmakematrix !== null && data !== null) {
      console.log('Updating ADAS Make Matrix', data)
      switch (data.name) {
        case 'id':
          state.adasmakematrix.adasChecklistMatrixVehicle = parseInt(data.value)
          state.adasmakematrix.id = parseInt(data.value)
          break
        case 'adasChecklistMatrix':
          state.adasmakematrix.adasChecklistMatrix = parseInt(data.value)
          break
        case 'make':
          state.adasmakematrix.vehicleMake = parseInt(data.value)
          break
        case 'yearStart':
          state.adasmakematrix.yearStart = parseInt(data.value)
          break
        case 'yearEnd':
          state.adasmakematrix.yearEnd = parseInt(data.value)
          break
        case 'system':
          state.adasmakematrix.system = data.value
          break
        case 'location':
          state.adasmakematrix.location = data.value
          break
        case 'isRR':
          state.adasmakematrix.isRR = data.value
          break
        case 'isRI':
          state.adasmakematrix.isRI = data.value
          break
        case 'calibrationType':
          state.adasmakematrix.calibrationType = parseInt(data.value)
          break
        case 'url':
          state.adasmakematrix.url = data.value
          break
        case 'isInactive':
          state.adasmakematrix.isInactive = data.value
          break
        case 'sort':
          state.adasmakematrix.sort = parseInt(data.value)
          break
        case 'source':
          state.adasmakematrix.source = data.value
          break
        case 'systemLookup':
          state.adasmakematrix.systems.push(data.value)
          break
        case 'removeSystem':
          state.adasmakematrix.systems = state.adasmakematrix.systems.filter((el) => {
            return el !== data.value
          })
          break
        case 'locationLookup':
          state.adasmakematrix.locations.push(data.value)
          break
        case 'removeLocation':
          state.adasmakematrix.locations = state.adasmakematrix.locations.filter((el) => {
            return el !== data.value
          })
          break
        case 'staticLookup':
          state.adasmakematrix.static.push(data.value)
          break
        case 'removeStatic':
          state.adasmakematrix.static = state.adasmakematrix.static.filter((el) => {
            return el !== data.value
          })
          break
        case 'dynamicLookup':
          state.adasmakematrix.dynamic.push(data.value)
          break
        case 'removeDynamic':
          state.adasmakematrix.dynamic = state.adasmakematrix.dynamic.filter((el) => {
            return el !== data.value
          })
          break
        case 'triggerNotice':
          state.adasmakematrix.triggerNotice = data.value
          break
        case 'triggerNoticeText':
          state.adasmakematrix.triggerNoticeText = data.value
          break
      }
    }
    console.log('Updated ADAS Make Matrix', state.adasmakematrix)
  },
  [types.INIT_ADAS_MATRIX_INFO_LOOKUP](state) {
    state.adasmatrixinfolookup = JSON.parse(JSON.stringify(state.newadasmatrixinfolookup))
    console.log('A new ADAS Matrix Info Lookup', state.adasmatrixinfolookup)
  },
  [types.UPDATE_ADAS_MATRIX_INFO_LOOKUP](state, data) {
    if (state.adasmatrixinfolookup !== null && data !== null) {
      console.log('Updating ADAS Matrix Info Lookup', data)
      switch (data.name) {
        case 'id':
          state.adasmatrixinfolookup.adasChecklistMatrixInfoLookup = null
          state.adasmatrixinfolookup.id = null
          if (data.value !== null) {
            state.adasmatrixinfolookup.adasChecklistMatrixInfoLookup = parseInt(data.value)
            state.adasmatrixinfolookup.id = parseInt(data.value)
          }
          break
        case 'adasChecklistMatrix':
          state.adasmatrixinfolookup.adasChecklistMatrix = null
          if (data.value !== null) {
            state.adasmatrixinfolookup.adasChecklistMatrix = parseInt(data.value)
          }
          break
        case 'make':
          state.adasmatrixinfolookup.vehicleMake = parseInt(data.value)
          break
        case 'yearStart':
          state.adasmatrixinfolookup.yearStart = parseInt(data.value)
          break
        case 'yearEnd':
          state.adasmatrixinfolookup.yearEnd = parseInt(data.value)
          break
        case 'keywords':
          state.adasmatrixinfolookup.keywords = data.value
          break
        case 'lookupType':
          state.adasmatrixinfolookup.lookupType = parseInt(data.value)
          break
        case 'url':
          state.adasmatrixinfolookup.url = data.value
          break
        case 'isInactive':
          state.adasmatrixinfolookup.isInactive = data.value
          break
        case 'sort':
          state.adasmatrixinfolookup.sort = parseInt(data.value)
          break
        case 'source':
          state.adasmatrixinfolookup.source = data.value
          break
      }
    }
    console.log('Updated ADAS Matrix Info Lookup', state.adasmatrixinfolookup)
  },
  [types.SET_ADAS_MAKE_MATRICES](state, data) {
    state.adasmakematrices = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.adasmakematrices = data
      }
    }
  },
  [types.SET_ADAS_MAKE_MATRIX_ID](state, data) {
    if (data !== undefined && data !== null) {
      state.adasmakematrix.adasChecklistMatrixVehicle = parseInt(data)
      state.adasmakematrix.id = parseInt(data)
    }
  },
  [types.SET_ADAS_MAKE_MATRIX](state, data) {
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.adasmakematrix = JSON.parse(JSON.stringify(data))
        state.adasmakematrix.systems = []
        if (data.systems !== undefined && data.systems !== null) {
          data.systems.forEach((element) => {
            state.adasmakematrix.systems.push(element.name)
          })
        }
        state.adasmakematrix.locations = []
        if (data.locations !== undefined && data.locations !== null) {
          data.locations.forEach((element) => {
            state.adasmakematrix.locations.push(element.name)
          })
        }
        state.adasmakematrix.static = []
        if (data.static !== undefined && data.static !== null) {
          data.static.forEach((element) => {
            state.adasmakematrix.static.push(element.name)
          })
        }
        state.adasmakematrix.dynamic = []
        if (data.dynamic !== undefined && data.dynamic !== null) {
          data.dynamic.forEach((element) => {
            state.adasmakematrix.dynamic.push(element.name)
          })
        }
      }
    }
  },
  [types.SET_ADAS_MATRIX_INFO_LOOKUPS](state, data) {
    state.adasmatrixinfolookups = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.adasmatrixinfolookups = data
      }
    }
  },
  [types.SET_ADAS_MATRIX_INFO_LOOKUP](state, data) {
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.adasmatrixinfolookup = JSON.parse(JSON.stringify(data))
      }
    }
  },
  [types.SET_ADAS_MATRIX_INFO_ID](state, data) {
    if (data !== undefined && data !== null) {
      state.adasmatrixinfolookup.adasChecklistMatrixInfoLookup = parseInt(data)
      state.adasmatrixinfolookup.id = parseInt(data)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/configuration/mutations.js